import Vue from 'vue'
import router from '@/router/index'
import { auth } from '@/services/api.js'
import axios from 'axios'

const getDefaultStateUser = () => {
  return {
    loggedIn: false,
    tokenExpiresAt: '',
    token:'',
    name:'',
    perfil:'',
    permisosOpcionMenu: [],
    opcionesMenu: [],
    dataEstadosGrafica:{}
  }
}
const getDefaultState = () => {
  return {
    packageVersion: process.env.VUE_APP_VERSION || '0',
    user: {
      loggedIn: false,
      tokenExpiresAt: '',
      token: '',
      name:'',
      id:'',
      perfil:0,
      estadoregistro:-1,
      permisosOpcionMenu: [],
      opcionesMenu: [],
      dataEstadosGrafica: {},
      dataRegistrosGrafica: {},
      empresa_id:'',
      empresa:'',
      minimacuantiaproveedor:0,
      menorcuantiaproveedor:0,
      minimacuantiacliente:0,
      menorcuantiacliente:0,
      colorapp:'',
      metodofirma:'',
      tiporegistro:'',
      selectidregistro:0,
      selectidempresa:0,
      multipleregistro:false,
      responsables:[]
    },
    lazyLoader: {
      loading: false,
      message: 'Cargando Recurso...'
    },
  }
}
// initial state
const state = getDefaultState()

// getters
const getters = {
  appVersion: (state) => state.packageVersion,
  auth: (state) => state.user,
  lazyLoader: (state) => state.lazyLoader,
  getPermisosOpcionMenu: state => Vue.prototype.lodash.map(state.user.permisosOpcionMenu, 'nombre'),
  // tienePermiso: (state, getters) => (permiso) => Vue.prototype.lodash.includes(getters.getPermisosOpcionMenu, permiso.toLowerCase()),
  tienePermiso: (state) => (codigo) => {
    var res = 0
    state.user.permisosOpcionMenu.forEach((value) => {
      if( value["codigo"] == codigo){        
        res = 1
      }
    });
    return res
  },
}

// actions
const actions = {
  resetUserState ({ commit }) {
    commit('setUser', getDefaultStateUser())
  },
  async fillMenu ({ commit, state }) {
    try {
      if (state.user.loggedIn) {
        commit('setLoaderMessage', 'Cargando Menú...')
        commit('saveLoaderState', true)
        //const { data: menu } = await auth.getMenu()
        //console.log(menu)
        //commit('saveOpcionesMenu', menu)
      }
    } catch (error) {
      // console.log(error)
      // Vue.prototype.$toasted.error(error, { icon: 'error', duration: 3000 })
    } finally {
      commit('saveLoaderState', false)
      commit('setLoaderMessage', 'Cargando Recurso...')
    }
  },
  async logout ({ commit }, error) {
    try {
      commit('setLoaderMessage', 'Finalizando Sesión de Usuario...')
      commit('saveLoaderState', true)
      if(error != 401){
        await auth.logout()
      }
      commit('setUser', getDefaultStateUser())
      
      Vue.prototype.$session.remove('user_token')
      Vue.prototype.$session.remove('user_name')
      Vue.prototype.$session.remove('user_perfil')
      Vue.prototype.$session.remove('user_menus')
      Vue.prototype.$session.remove('user_permisos')
      Vue.prototype.$session.remove('user_id')
      Vue.prototype.$session.remove('estadoregistro')
      Vue.prototype.$session.remove('user_empresa_id')
      Vue.prototype.$session.remove('user_empresa')
      Vue.prototype.$session.remove('colorapp')
      Vue.prototype.$session.remove('minimacuantiaproveedor')
      Vue.prototype.$session.remove('menorcuantiaproveedor')
      Vue.prototype.$session.remove('minimacuantiaclientes')
      Vue.prototype.$session.remove('menorcuantiaclientes')
      Vue.prototype.$session.remove('metodofirmaregistro')
      Vue.prototype.$session.remove('tiporegistro')
      Vue.prototype.$session.remove('selectidregistro')
      Vue.prototype.$session.remove('selectidempresa')

      router.push({ path: "/login" })
    } catch (error) {
      console.log('store logout',error)
      commit('setUser', getDefaultStateUser())
      Vue.prototype.$session.remove('user_token')
      Vue.prototype.$session.remove('user_name')
      Vue.prototype.$session.remove('user_perfil')
      Vue.prototype.$session.remove('user_menus')
      Vue.prototype.$session.remove('user_permisos')
      Vue.prototype.$session.remove('user_id')
      Vue.prototype.$session.remove('estadoregistro')
      Vue.prototype.$session.remove('user_empresa_id')
      Vue.prototype.$session.remove('user_empresa')
      Vue.prototype.$session.remove('colorapp')
      Vue.prototype.$session.remove('minimacuantiaproveedor')
      Vue.prototype.$session.remove('menorcuantiaproveedor')
      Vue.prototype.$session.remove('minimacuantiaclientes')
      Vue.prototype.$session.remove('menorcuantiaclientes')
      Vue.prototype.$session.remove('metodofirmaregistro')
      Vue.prototype.$session.remove('tiporegistro')
      Vue.prototype.$session.remove('selectidregistro')
      Vue.prototype.$session.remove('selectidempresa')

      commit('saveLoaderState', false)
      commit('setLoaderMessage', 'Cargando Recurso...')
      commit('resetState')
      // Vue.prototype.$toasted.error(error, { icon: 'error', duration: 3000 })
    } finally {
      commit('saveLoaderState', false)
      commit('setLoaderMessage', 'Cargando Recurso...')
      commit('savecolorappState', 0)
      commit('resetState')
    }
  }
}

// mutations
const mutations = {
  setUser (state, payload) {
    Object.assign(state.user, payload)
  },
  saveLoaderState (state, status) {
    state.lazyLoader.loading = status
  },
  setLoaderMessage (state, text) {
    state.lazyLoader.message = text
  },
  saveLoggedState (state, status) {
    state.user.loggedIn = status
  },
  saveLoginNameState (state, Name) {
    state.user.Name = Name
  },
  saveEstadoRegistroState (state, Estado) {
    state.user.estadoregistro = Estado
  },
  saveLoginIdState (state, Id) {
    state.user.Id = Id
  },
  saveLoginPerfilState (state, perfil) {
    state.user.perfil = perfil
  },
  saveLoginIdEmpresaState (state, idempresa) {
    state.user.empresa_id = idempresa
  },
  saveLoginEmpresaState (state, empresa) {
    state.user.empresa = empresa
  },
  saveLoginTokenState (state, token) {
    state.user.token = token
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  },
  saveLoggedState (state, status) {
    state.user.loggedIn = status
  },
  setAvatar: (state, sexo) => {
    if (sexo === 'M') state.user.avatar = 'avatar_man.png'
    else if (sexo === 'F') state.user.avatar = 'avatar_woman.png'
  },
  saveTokenDateExpires (state, fecha) {
    state.user.tokenExpiresAt = fecha
  },
  saveOpcionesMenu (state, menu) {
    state.user.opcionesMenu = menu
  },
  savePermisosOpcionMenu (state, permisos) {
    state.user.permisosOpcionMenu = permisos
  },
  saveResponsables (state, responsables) {
    state.user.responsables = responsables
  },  
  savedataEstadosGrafica (state, data) {
    state.user.dataEstadosGrafica = data
  },
  savedataRegistrosGrafica (state, data) {
    state.user.dataRegistrosGrafica = data
  },  
  savecolorappState (state,colorapp){
    state.user.colorapp = colorapp
  },
  saveminimacuantiaproveedorState (state,minimacuantiaproveedor){
    state.user.minimacuantiaproveedor = minimacuantiaproveedor
  },
  savemenorcuantiaproveedorState (state,menorcuantiaproveedor){
    state.user.menorcuantiaproveedor = menorcuantiaproveedor
  },
  saveminimacuantiaclientesState (state,minimacuantiacliente){
    state.user.minimacuantiacliente = minimacuantiacliente
  },
  savemenorcuantiaclientesState (state,menorcuantiacliente){
    state.user.menorcuantiacliente = menorcuantiacliente
  },
  saveMetodoFirmaRegistroState (state,metodofirma){
    state.user.metodofirma = metodofirma
  },  
  saveTipoRegistroState (state,tiporegistro){
    state.user.tiporegistro = tiporegistro
  },
  saveselectidregistroState (state,selectidregistro){
    state.user.selectidregistro = selectidregistro
  },
  saveselectidempresaState (state,selectidempresa){
    state.user.selectidempresa = selectidempresa
  },
  savemultipleregistroState (state,multipleregistro){
    state.user.multipleregistro = multipleregistro
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
